module.exports = __webpack_public_path__ + "87a7189626963402bbcdf2c54be05a47.jpg";


//////////////////
// WEBPACK FOOTER
// ./photo.jpg
// module id = 491
// module chunks = 0